import React, {useEffect, useState} from 'react';
import SideNavbar from '../../Components/SideNavbar';
import './CSS/Settings.css';
import {useMsal} from "@azure/msal-react";
import { toggleSentimentAnalysis, toggleOutlook, toggleWord, toggleTeams } from '../../Services/ToggleFeatures';


type ToggleState = {
    sentimentAnalysis: boolean;
    outlook: boolean;
    word: boolean;
    teams: boolean;
};

const Settings: React.FC = () => {

    const { instance, accounts } = useMsal();

    const [toggleState, setToggleState] = useState<ToggleState>({
        sentimentAnalysis: true,
        outlook: true,
        word: true,
        teams: true,
    });


    useEffect(() => {
        const storedSentimentEnabled = localStorage.getItem('isSentimentEnabled');
        const storedTeamsEnabled = localStorage.getItem('isTeamsEnabled');
        const storedOutlookEnabled = localStorage.getItem('isOutlookEnabled');
        const storedWordEnabled = localStorage.getItem('isWordEnabled');

        setToggleState({
            sentimentAnalysis: storedSentimentEnabled === 'true',
            outlook: storedOutlookEnabled === 'true',
            word: storedWordEnabled === 'true',
            teams: storedTeamsEnabled === 'true'
        });
    }, []);


    const handleToggle = async (key: keyof ToggleState) => {
        const newToggleState = !toggleState[key];
        setToggleState(prevState => ({
            ...prevState,
            [key]: newToggleState,
        }));

        try {
            const idToken = localStorage.getItem('subjectToken') || '';
            const accessToken = localStorage.getItem('accessToken') || '';

            if (key === 'sentimentAnalysis') {
                await toggleSentimentAnalysis(idToken, accessToken, newToggleState);
                localStorage.setItem('isSentimentEnabled', newToggleState.toString());
            } else if (key === 'outlook') {
                await toggleOutlook(idToken, accessToken, newToggleState);
                localStorage.setItem('isOutlookEnabled', newToggleState.toString());
            } else if (key === 'word') {
                await toggleWord(idToken, accessToken, newToggleState);
                localStorage.setItem('isWordEnabled', newToggleState.toString());
            } else if (key === 'teams') {
                await toggleTeams(idToken, accessToken, newToggleState);
                localStorage.setItem('isTeamsEnabled', newToggleState.toString());
            }

        } catch (error) {
            console.error('Error during token acquisition or backend call:', error);
        }
    };

    return (
        <div className="settings-page">
            <SideNavbar />
            <div className="settings-content">
                <h1>Settings</h1>
                <div className="settings-section">
                    <h2>Application Features</h2>

                    <div className="settings-row">
                        <span>Toggle sentiment analysis</span>
                        <div
                            className={`toggle-switch ${toggleState.sentimentAnalysis ? 'on' : 'off'}`}
                            onClick={() => handleToggle('sentimentAnalysis')}
                        >
                            <span className="toggle-handle" />
                        </div>
                    </div>

                    <div className="settings-row">
                        <span>Allow desktop app for outlook</span>
                        <div
                            className={`toggle-switch ${toggleState.outlook ? 'on' : 'off'}`}
                            onClick={() => handleToggle('outlook')}
                        >
                            <span className="toggle-handle" />
                        </div>
                    </div>

                    <div className="settings-row">
                        <span>Allow desktop app for word</span>
                        <div
                            className={`toggle-switch ${toggleState.word ? 'on' : 'off'}`}
                            onClick={() => handleToggle('word')}
                        >
                            <span className="toggle-handle" />
                        </div>
                    </div>

                    <div className="settings-row">
                        <span>Allow desktop app for teams</span>
                        <div
                            className={`toggle-switch ${toggleState.teams ? 'on' : 'off'}`}
                            onClick={() => handleToggle('teams')}
                        >
                            <span className="toggle-handle" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Settings;
